import IBloc from '../../base/IBloc';
import { NewsService } from '../../service/supabase/NewsService';
import { CreateNewsDto, NewsViewState, UpdateNewsDto } from '../../types/news.types';

export class BlocManagementNews extends IBloc {
    private service: NewsService;

    /**
     * State chính của News Management
     */
    info: NewsViewState = {
        news: [],
        pagination: {
            total: 0,
            page: 1,
            limit: 10,
            totalPages: 0
        },
        loading: false,
        error: null,
        filters: {},
        hasData: false
    };

    // Keep track of the current pagination settings
    currentPagination = {
        page: 1,
        limit: 10
    };

    constructor() {
        super();
        this.service = new NewsService();
    }

    async initData() {
        try {
            this.info = {
                ...this.info,
                loading: true,
                error: null
            };
            this.setStream('info', this.info);

            const { news, pagination } = await this.service.getAllNews(
                this.currentPagination.page,
                this.currentPagination.limit
            );

            this.info = {
                ...this.info,
                news,
                pagination,
                loading: false,
                hasData: news.length > 0,
                error: null
            };
            this.setStream('info', this.info);
        } catch (error) {
            this.info = {
                ...this.info,
                loading: false,
                error: 'Có lỗi xảy ra khi tải dữ liệu'
            };
            this.setStream('info', this.info);
            console.error('Error fetching news:', error);
        }
    }

    async refresh() {
        this.currentPagination.page = 1;
        await this.initData();
    }

    async changePage(page: number) {
        this.currentPagination.page = page;
        await this.initData();
    }

    async changePageSize(limit: number) {
        this.currentPagination.limit = limit;
        this.currentPagination.page = 1;
        await this.initData();
    }

    async createNews(newsData: CreateNewsDto) {
        try {
            const createdNews = await this.service.createNews(newsData);
            await this.initData();
            return createdNews;
        } catch (error) {
            console.error('Error creating news:', error);
            throw error;
        }
    }

    async updateNews(id: string, newsData: UpdateNewsDto) {
        try {
            const updatedNews = await this.service.updateNews(id, newsData);
            await this.initData();
            return updatedNews;
        } catch (error) {
            console.error('Error updating news:', error);
            throw error;
        }
    }

    async deleteNews(id: string) {
        try {
            await this.service.deleteNews(id);
            await this.initData();
            return true;
        } catch (error) {
            console.error('Error deleting news:', error);
            throw error;
        }
    }
}
